import { Component, OnInit, Inject, Directive, AfterViewInit, ElementRef, Input, ChangeDetectorRef, NgZone } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { OrderDialogComponent } from '../order-dialog/order-dialog.component';
import { DomSanitizer } from '@angular/platform-browser';
import { AngularFirestore } from '@angular/fire/firestore/';
import { FormBuilder } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AngularFireStorage } from '@angular/fire/storage/';
import { AngularFireAuth } from '@angular/fire/auth/';
import { LoginDialogComponent } from '../login-dialog/login-dialog.component';
import { userInfo } from 'os';
import { ClipsDialogComponent } from '../clips-dialog/clips-dialog.component';
import { LoadingDialogComponent } from '../loading-dialog/loading-dialog.component';
import { UserPanelService } from '../user-panel.service';
import { UplatnicaDialogComponent } from '../uplatnica-dialog/uplatnica-dialog.component';
import { Router, ActivatedRoute } from '@angular/router';
import { NewPasswordDialogComponent } from '../new-password-dialog/new-password-dialog.component';
import { SubjectUpgradeDialogComponent } from '../subject-upgrade-dialog/subject-upgrade-dialog.component';
import { ReservationPopupComponent } from '../reservation-popup/reservation-popup.component';
import { AngularFireFunctions } from '@angular/fire/functions';
import { QuizService } from '../quiz/quiz.service';
import { NotificationDialogComponent } from '../app.component';

@Component({
  selector: 'app-user-panel',
  templateUrl: './user-panel.component.html',
  styleUrls: ['./user-panel.component.scss']
})
export class UserPanelComponent implements OnInit {
  tab = 'subjects'
  order_id = null
  tabs = ['subjects', 'orders', 'reservations', 'tests']
  constructor(
    private sanitizer: DomSanitizer,
    private firestore: AngularFirestore,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private auth: AngularFireAuth,
    private _snackBar: MatSnackBar,
    private storage: AngularFireStorage,
    private dialog: MatDialog,
    private fsFuncs: AngularFireFunctions,
    private router: Router,
    public zone: NgZone,
    private route: ActivatedRoute,
    private userPanelService: UserPanelService) {

    // this.dialog.open(NotificationDialogComponent, {
    //   width: '50%'
    // })
    this.showOrderFromEmail();
    var mode = this.route.snapshot.queryParamMap.get('mode');
    var oobCode = this.route.snapshot.queryParamMap.get('oobCode');
    var customToken = this.route.snapshot.queryParamMap.get('customToken');
    if (oobCode != null && mode === "resetPassword") {
      auth.verifyPasswordResetCode(oobCode)
        .then((email) => {
          var dialogRef = dialog.open(NewPasswordDialogComponent, {
            data: {
              oobCode: oobCode,
              email: email
            }
          })
          dialogRef.afterClosed()
            .subscribe((statusCode) => {
              if (statusCode === 200) this.openSnackBar("Lozinka promenjena", "OK");
              else if (statusCode === 400) this.openSnackBar("Lozinka nije promenjena", "OK");
            })
        })
        .catch((err) => {
          console.log(err);
          this.openSnackBar("Zahtev istekao ili nije validan!", "OK");
        })
    }
    auth.onAuthStateChanged(async (userInfo) => {
      if (!userInfo) {
        if (oobCode == null && customToken == null) {
          window.location.href = 'kalkulator'
        }
        if (customToken != null) {
          auth.signInWithCustomToken(customToken)
        }
      }
    })
  }
  showOrderFromEmail() {
    var tab = this.route.snapshot.queryParamMap.get('tab');
    this.order_id = this.route.snapshot.queryParamMap.get('oid');
    if (tab) this.tab = tab;
  }

  signOut() {
    this.auth.signOut();
  }

  openLoginDialog() {
    var width = '40%';
    if (window.outerWidth < 992) width = "80%"
    const dialogRef = this.dialog.open(LoginDialogComponent, {
      width: width,
      height: '90%',
      // data: {},
      panelClass: 'submitDialogStyle'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 200) this.openSnackBar("Ulogovan!", "ok")
      else this.openSnackBar("Greška pri logovanju. Neuspešno.", "ok")
    });
  }
  openSnackBar(message: string, action: string, top?: boolean) {
    this._snackBar.open(message, action, {
      duration: 2000,
      verticalPosition: (top) ? 'top' : 'bottom'
    });
  }
  ngOnInit(): void {
  }

}
@Component({
  selector: 'app-user-panel-order-upgrade',
  templateUrl: './user-panel-order-upgrade.html',
  styleUrls: ['./user-panel-order-upgrade.scss']
})
export class UserPanelOrderUpgradeComponent implements OnInit {
  @Input() order;
  constructor(
    private firestore: AngularFirestore,
    private auth: AngularFireAuth,
    private dialog: MatDialog
  ) { }
  ngOnInit() { }


}